import { render, staticRenderFns } from "./affiliate-program.vue?vue&type=template&id=8040b494&scoped=true&"
import script from "./affiliate-program.vue?vue&type=script&lang=js&"
export * from "./affiliate-program.vue?vue&type=script&lang=js&"
import style0 from "./affiliate-program.vue?vue&type=style&index=0&id=8040b494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8040b494",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AffiliateProgramHeader: require('/home/runner/work/webpage/webpage/components/affiliate-program/header/header.vue').default,AffiliateProgramGoodFit: require('/home/runner/work/webpage/webpage/components/affiliate-program/good-fit/good-fit.vue').default,AffiliateProgramPerks: require('/home/runner/work/webpage/webpage/components/affiliate-program/perks/perks.vue').default,BaseTestimonialsVideo: require('/home/runner/work/webpage/webpage/components/base/testimonials-video/testimonials-video.vue').default,AffiliateProgramPartnerships: require('/home/runner/work/webpage/webpage/components/affiliate-program/partnerships/partnerships.vue').default,AffiliateProgramFeaturedIn: require('/home/runner/work/webpage/webpage/components/affiliate-program/featured-in/featured-in.vue').default,AffiliateProgramFloatingButton: require('/home/runner/work/webpage/webpage/components/affiliate-program/floating-button/floating-button.vue').default})
